import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import WebhookEndpoint from "../../models/webhook-endpoint";
import WebhookEndpointForm from "./WebhookEndpointForm";

interface WebhookEndpointEditModalProps {
  show: boolean;
  endpoint?: WebhookEndpoint;
  onCancel: () => void | Promise<void>;
  onSuccess: (_?: WebhookEndpoint) => void | Promise<void>;
}

const WebhookEndpointEditModal: React.FC<WebhookEndpointEditModalProps> = ({
  show,
  endpoint,
  onCancel,
  onSuccess,
}) => {
  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Editar Webhook</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show && endpoint ? (
            <WebhookEndpointForm
              endpoint={endpoint}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default WebhookEndpointEditModal;
